export const getScopeGroupI18nKey = (scopeGroup, key = 'label') => {
  return `developer-experience-shared-components.scopes.scopeGroups.${scopeGroup.replace(/\./g, '-')}.${key}`;
};